module.exports = __webpack_public_path__ + "static/media/searchUser.946acb7b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/SearchPerson/img/searchUser.svg
// module id = 1469
// module chunks = 0